import { normalize } from 'normalizr';
import uid from 'uid';
import * as schema from '../api/schema';
import * as api from '../api';
import { getIsFetching } from '../reducers/manips';

export const FETCH_MANIPS = 'intervention.FETCH_MANIPS';
export const FETCH_MANIPS_SUCCESS = 'intervention.FETCH_MANIPS_SUCCESS';
export const FETCH_MANIPS_ERROR = 'intervention.FETCH_MANIPS_ERROR';
export const CREATE_MANIP = 'intervention.CREATE_MANIP';
export const UPDATE_MANIP = 'intervention.UPDATE_MANIP';
export const DELETE_MANIP = 'intervention.DELETE_MANIP';

export const CREATE_PREINSTALL_MANIP = 'intervention.CREATE_PREINSTALL_MANIP';
export const UPDATE_PREINSTALL_MANIP = 'intervention.UPDATE_PREINSTALL_MANIP';
export const DELETE_PREINSTALL_MANIP = 'intervention.DELETE_PREINSTALL_MANIP';

const requestManips = () => ({
  type: FETCH_MANIPS,
});

const receiveManips = response => ({
  type: FETCH_MANIPS_SUCCESS,
  response: normalize(response, schema.arrayOfManipulations),
});

export const fetchManips = (type, intervention) => (dispatch, getState) => {
  const state = getState();
  if (getIsFetching(state)) {
    return Promise.resolve();
  }

  dispatch(requestManips());

  // Request interventions fetching then planning
  return api.getManipulationsForType(type, intervention).then(
    response => dispatch(receiveManips(response)),
    err => {
      if (err.res.status === 404) {
        // No rat manips found, dispatching success
        dispatch(receiveManips([]));
      } else {
        dispatch({
          type: FETCH_MANIPS_ERROR,
          error: err,
        });
      }
    }
  );
};

export const createManip = (zone, data) => dispatch => {
  const manip = {
    ...data,
    zone_id: zone,
    new: true,
    id: uid(),
  };

  const normalized = normalize(manip, schema.manipulation);
  console.log();
  dispatch({
    type: CREATE_MANIP,
    response: normalized,
  });
};

export const updateManip = manip => dispatch => {
  dispatch({
    type: UPDATE_MANIP,
    response: normalize(manip, schema.manipulation),
  });
};

export const deleteManip = manip => dispatch => {
  dispatch({
    type: DELETE_MANIP,
    manip,
  });
};

export const uploadImage = file => {
  const data = new FormData();
  data.append('file', file);

  return fetch('/pco-manager/async-resource/save', {
    method: 'POST',
    'Content-Type': 'multipart/form-data',
    body: data,
  }).then(res => res.json());
};



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/actions/manips.js